export default {
    RedesSociais: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "redes-sociais"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/RedesSociais.js
// module id = vuEb
// module chunks = 32